var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('div',{attrs:{"id":"container"}},[_c('nav',[_c('router-link',{attrs:{"to":"/"}},[_vm._v("系统大屏")]),_vm._v(" |\n\n    ")],1),_c('router-view')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }